<nz-modal [(nzVisible)]="isVisible" nzTitle="Client Addreses" [nzWidth]="'80%'" (nzOnCancel)="closeModal()"
  [nzCancelText]="null" [nzFooter]="modalFooter">
  <ng-container *nzModalContent>
    <!-- <nz-table #basicTable [nzData]="data" [nzBordered]="false" [nzSize]="'small'"
      [nzShowPagination]="'false'">
      <thead>
        <tr>
          <th>Type</th>
          <th>Address 1</th>
          <th>Address 2</th>
          <th>City</th>
          <th>State</th>
          <th>Country</th>
            <th>Zip code</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let address of data">
          <td>{{ address?.address_type_name === 'Official' || address?.address_type_name === 'official' ? 'Headquarter' : address?.address_type_name }}</td>
          <td style="width:140px">{{address?.address_field_1}}</td>
          <td style="width:140px">{{address?.address_field_1}}</td>
          <td>{{address?.city_name}}</td>
          <td>{{address?.state_name}}</td>
          <td>{{address?.country_name}}</td>
          <td>{{address?.zip_code}}</td>
          <td>
            <button nz-button nzType="default" nzSize="small" style="margin-left: 8px;" nz-tooltip
              [nzTooltipTitle]="'Edit'" (click)="updateAddress(address)" nzTooltipPlacement="top"><nz-icon nzType="edit"
                nzTheme="outline" /></button>
            <button nz-button nzType="default" nzDanger nzSize="small" style="margin-left: 8px;" nz-tooltip
              [nzTooltipTitle]="'Delete'" (click)="deleteAddress(address)" nzTooltipPlacement="top"><nz-icon
                nzType="delete" nzTheme="outline" /></button>
          </td>
        </tr>
      </tbody>
    </nz-table> -->


    <nz-row [nzGutter]="24">
      <nz-col *ngFor="let address of data; let i = index; e" [nzSpan]="12">
        <div class="address-wrapper shadow">
          <div style="flex: 1; margin-bottom: 20px;">
            <ng-template #addressheaderTemplate>

              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div>
                  <!-- <nz-icon [nzType]="getAddressIcon(address?.address_type_name)"
                    [nzTheme]="getIconTheme(address?.address_type_name)" class="address-icon" /> -->
                  {{ address?.address_type_name.toLowerCase() === 'official' ? 'Headquarter' :
                  address?.address_type_name }} Address ({{i+1}})
                </div>

                <div>
                  <button nz-button nzType="text" nzSize="small" style="margin-left: 8px;" nz-tooltip
                    [nzTooltipTitle]="'Edit'" (click)="updateAddress(address)" nzTooltipPlacement="top"><nz-icon
                      nzType="edit" nzTheme="outline" /></button>

                  <button nz-button nzType="text" nzDanger nzSize="small" style="margin-left: 8px;" nz-tooltip
                    [nzTooltipTitle]="'Delete'" (click)="deleteAddress(address)" nzTooltipPlacement="top"><nz-icon
                      nzType="delete" nzTheme="outline" /></button>
                </div>

              </div>



            </ng-template>
            <nz-descriptions [nzColumn]="1" nzSize="small" [nzTitle]="addressheaderTemplate" nzBordered>
              <nz-descriptions-item nzTitle="Address Line 1">{{ address?.address_field_1 }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="Address Line 2">{{ address?.address_field_2 }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="City">{{ address?.city_name }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="State">{{ address?.state_name }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="Country">{{ address?.country_name }}</nz-descriptions-item>
              <nz-descriptions-item nzTitle="Zip Code">{{ address?.zip_code }}</nz-descriptions-item>
              <!-- <nz-descriptions-item nzTitle="Address Type">{{ address?.address_type_name }}</nz-descriptions-item> -->
            </nz-descriptions>

          </div>



          <!-- <span style="cursor: pointer;margin-right:10px"  (click)="updateAddress(address)">
            <nz-icon nzType="edit" nzTheme="fill" /></span>
           <span style="cursor: pointer;"  (click)="deleteAddress(address)">
            <nz-icon nzType="delete" nzTheme="fill"  /></span> -->

        </div>
      </nz-col>
    </nz-row>



  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="closeModal()">Cancel</button>
  </ng-template>
</nz-modal>